"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _customerFeedback = require("@/types/customer-feedback");
var CustomerFeedbackTable = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CustomerFeedbackTable, _Vue);
  var _super = (0, _createSuper2.default)(CustomerFeedbackTable);
  function CustomerFeedbackTable() {
    var _this;
    (0, _classCallCheck2.default)(this, CustomerFeedbackTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "FeedbackStatusTrans", _customerFeedback.FeedbackStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "FeedbackTagOptions", _customerFeedback.FeedbackTagOptions);
    return _this;
  }
  return (0, _createClass2.default)(CustomerFeedbackTable);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerFeedbackTable.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CustomerFeedbackTable.prototype, "loading", void 0);
CustomerFeedbackTable = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], CustomerFeedbackTable);
var _default = CustomerFeedbackTable;
exports.default = _default;